import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-single-option-selector-model',
    templateUrl: './single-option-selector-model.component.html',
    styleUrls: ['./single-option-selector-model.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class SingleOptionSelectorModelComponent {
    @Input() options: any;
    @Input() selectedObj: any;
    @Input() title: string = 'Please Select'; //as default, if no title

    constructor(private modalCtrl: ModalController) {}

    optionSelect(item: any) {
        //console.log(item);
        this.selectedObj = item;
    }

    submit() {
        this.modalCtrl.dismiss(this.selectedObj);
    }

    closeModal() {
        this.modalCtrl.dismiss();
    }
}
